import { render, staticRenderFns } from "./reviewWordCard.vue?vue&type=template&id=6a4fb000&scoped=true"
import script from "./reviewWordCard.vue?vue&type=script&lang=js"
export * from "./reviewWordCard.vue?vue&type=script&lang=js"
import style0 from "./reviewWordCard.vue?vue&type=style&index=0&id=6a4fb000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4fb000",
  null
  
)

export default component.exports